export default __webpack_public_path__ + "static/media/przelew.70570e37.svg";